import { useMemo } from "react";
import { useModels } from "@/contexts/models";
import {
  resolveMemberProviderIconPath,
  resolveMemberProviderSlug,
  type ReferenceMember,
} from "./creferenceResolvedEntitySelectors";

interface UseCreferenceMemberProviderFieldsInput {
  member: ReferenceMember | null;
}

export interface CreferenceMemberProviderFields {
  memberProviderIconPath: string;
  memberProviderSlug: string;
}

export function useCreferenceMemberProviderFields({
  member,
}: UseCreferenceMemberProviderFieldsInput): CreferenceMemberProviderFields {
  const { getModel, getUniqueVendors } = useModels();
  const memberProviderSlug = useMemo(
    () => resolveMemberProviderSlug({ getModel, getUniqueVendors, member }),
    [getModel, getUniqueVendors, member],
  );
  const memberProviderIconPath = useMemo(
    () => resolveMemberProviderIconPath({ member, memberProviderSlug }),
    [member, memberProviderSlug],
  );

  return {
    memberProviderIconPath,
    memberProviderSlug,
  };
}
